"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _labeling = _interopRequireDefault(require("../labeling"));
var _PaymentMethod = _interopRequireDefault(require("../../components/PaymentMethod"));
var _SectionHeader = _interopRequireDefault(require("../../components/SectionHeader"));
var _Transactions = _interopRequireDefault(require("../../components/Transactions"));
var _propTypes = require("prop-types");
var _UpdatePaymentDetailsPopup = _interopRequireDefault(require("../../components/UpdatePaymentDetailsPopup"));
var _reactRedux = require("react-redux");
var _GracePeriodError = _interopRequireDefault(require("../../components/GracePeriodError"));
var _publisherConfigSlice = require("../../redux/publisherConfigSlice");
var _WithAddPaymentDetailsFinalizationHandler = _interopRequireDefault(require("../WithAddPaymentDetailsFinalizationHandler"));
var _popupSlice = require("../../redux/popupSlice");
var _PaymentInfoStyled = require("./PaymentInfoStyled");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable react/forbid-prop-types */

var PaymentInfo = function PaymentInfo(_ref) {
  var adyenConfigurationProp = _ref.adyenConfiguration,
    t = _ref.t,
    displayGracePeriodError = _ref.displayGracePeriodError;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.publisherConfig;
    }),
    adyenConfigurationStore = _useSelector.adyenConfiguration;
  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
      return state.popupManager;
    }),
    paymentDetailsPopup = _useSelector2.paymentDetails;
  var adyenConfiguration = adyenConfigurationProp || adyenConfigurationStore;
  (0, _react.useEffect)(function () {
    dispatch((0, _publisherConfigSlice.init)({
      adyenConfiguration: adyenConfiguration
    }));
    if (displayGracePeriodError !== null) {
      dispatch((0, _publisherConfigSlice.init)({
        displayGracePeriodError: displayGracePeriodError
      }));
    }
    return function () {
      dispatch((0, _popupSlice.updatePaymentDetailsPopup)({
        isOpen: false
      }));
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_PaymentInfoStyled.WrapStyled, null, /*#__PURE__*/_react.default.createElement(_GracePeriodError.default, null), paymentDetailsPopup.isOpen ? /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "payment-info__update-payment-details-popup"
  }, /*#__PURE__*/_react.default.createElement(_UpdatePaymentDetailsPopup.default, null)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SectionHeader.default, null, t('Current payment method')), /*#__PURE__*/_react.default.createElement(_PaymentMethod.default, null), /*#__PURE__*/_react.default.createElement(_SectionHeader.default, {
    marginTop: "25px"
  }, t('Payment history')), /*#__PURE__*/_react.default.createElement(_Transactions.default, null)));
};
PaymentInfo.propTypes = {
  adyenConfiguration: _propTypes.PropTypes.objectOf(_propTypes.PropTypes.any),
  t: _propTypes.PropTypes.func,
  displayGracePeriodError: _propTypes.PropTypes.bool
};
PaymentInfo.defaultProps = {
  adyenConfiguration: null,
  t: function t(k) {
    return k;
  },
  displayGracePeriodError: null
};
var _default = (0, _reactI18next.withTranslation)()((0, _labeling.default)()((0, _WithAddPaymentDetailsFinalizationHandler.default)(PaymentInfo)));
exports.default = _default;